import {
  EUROSTAR,
  EUROSTAR_ORGANIZATION,
  OFFICE,
  THALYS_OFFICES,
  THALYS_ADMIN_OFFICE,
  THALYS_ADMIN_OR_SUPER_USER_OFFICES,
  LOUNGE_STAFF_OFFICES,
  DC_OFFICES,
  SPX_STATION_USER
} from 'types/constants';
import { Location } from 'types/payments';
import { USER_TYPES } from '../types/user';

export const isUserEurostarAgent = (user) => user?.salesChannel?.toUpperCase() === EUROSTAR;
export const isUserStationAgent = (user) => user?.offices?.some((office) => office.isStation);
export const isUserThalysAgent = (user) => user?.offices?.some((office) => THALYS_OFFICES.includes(office?.name));
export const isUserInEBSCOffice = (user) => {
  const { paymentLocation: { __typename, name } = {} } = user || {};

  return __typename === OFFICE && name.includes(Location.EBSC);
};
export const isThalysAdminOrSuperUser = (user) =>
  user?.offices?.some((office) => THALYS_ADMIN_OR_SUPER_USER_OFFICES.includes(office?.name));
export const isThalysAdminUser = (user) => user?.offices?.some((office) => [THALYS_ADMIN_OFFICE].includes(office?.name));
export const isUserInCSCGroup = (user) => user?.offices?.some((office) => ['CSC_GROUP'].includes(office.name));
export const userCanOfferQuotes = (user) => user?.organization?.code === EUROSTAR_ORGANIZATION && !isUserThalysAgent(user);
export const isTravelAgent = (user) => user?.organization?.code !== EUROSTAR_ORGANIZATION;
export const isUserInCSCOffice = (user) => {
  const { paymentLocation: { __typename, name } = {} } = user || {};

  return __typename === OFFICE && name.includes(Location.CSC);
};
export const isLoungeStaff = (user) =>
  user?.organization?.code === EUROSTAR_ORGANIZATION && user?.offices?.some((office) => LOUNGE_STAFF_OFFICES.includes(office?.name));

export const isDCOffice = (user) => user?.offices?.some((office) => DC_OFFICES.includes(office?.name));
export const isUserCallCenterAgent = (user) => user?.organization?.code === EUROSTAR_ORGANIZATION && !isUserStationAgent(user);

export const getUserType = (user) => {
  if (isUserStationAgent(user)) {
    return USER_TYPES.STATION_USER;
  }

  if (isUserEurostarAgent(user)) {
    return USER_TYPES.ANY_OTHER_ES_USER;
  }

  if (isTravelAgent(user)) {
    return USER_TYPES.TRAVEL_AGENT;
  }
};

export const isEurostarOrganization = (user) => user?.organization?.code === EUROSTAR_ORGANIZATION;
export const isSPXUser = ({ user }) => user.offices?.some(({ name }) => name === SPX_STATION_USER) ?? false;
